import { useState, useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { api } from "@/utils/api";
import { Loader2 } from "lucide-react";

const ProtectedRoute = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null); // null = checking, true = authenticated, false = not authenticated
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    checkAuthentication();
  }, []);

  const checkAuthentication = async () => {
    const sessionToken = localStorage.getItem("session_token");

    if (!sessionToken) {
      setIsAuthenticated(false);
      setIsLoading(false);
      return;
    }

    try {
      // Verify session is valid
      const response = await api.get(`/auth/me`, {
        headers: {
          Authorization: `Bearer ${sessionToken}`
        }
      });

      if (response.data) {
        setIsAuthenticated(true);
        // Update user data in localStorage
        localStorage.setItem("user", JSON.stringify(response.data));
      } else {
        setIsAuthenticated(false);
        localStorage.removeItem("session_token");
        localStorage.removeItem("user");
      }
    } catch (error) {
      setIsAuthenticated(false);
      localStorage.removeItem("session_token");
      localStorage.removeItem("user");
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-sky-50 via-blue-50 to-indigo-100">
        <div className="text-center">
          <Loader2 className="h-12 w-12 animate-spin mx-auto text-sky-600 mb-4" />
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    // Redirect to login page, but save the attempted location
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute;
